import type { Action } from '~/jet/models';

export interface GetTrackMetadataAction extends Action {
    $kind: 'getTrackMetadataAction';
    trackIds: string[];
    queue: Array<unknown>;
}

export const makeGetTrackMetadataAction = (
    trackIds: string[],
    queue: Array<unknown>,
): GetTrackMetadataAction => {
    return {
        $kind: 'getTrackMetadataAction',
        trackIds,
        queue,
        actionMetrics: {
            data: [],
            custom: {},
        },
    };
};
